import { Strings } from './Strings';

export const getFrFrStrings = () : Strings => ({
  SESSION_EXPIRED: 'Session expirée!',
  BOOLEAN_ATTRIBUTE_YES: 'Oui',
  BOOLEAN_ATTRIBUTE_NO: 'Non',
  PAGE_NOT_FOUND: 'Page non trouvée...',
  COLLECTIONS_HEADER_LABEL: 'Collections',
  SEARCH_HEADER_LABEL: 'Recherche',
  INFORMATION_SLIDER_BUTTON: '+ INFORMATIONS',
  NEXT_SLIDER_SPAN: 'Suivant',
  PREVIOUS_SLIDER_SPAN: 'Précédent',
  SPOTLIGHT_OBJECTS_LABEL: 'Bottes d´équitation sur mesure, fabriquées exclusivement pour vous.',
  MENU_FOOTER_LABEL: 'Menu',
  FILTERS_LABEL: 'Filtres',
  VARIANTS_OBJECT_LABEL: 'Variantes',
  ADD_TO_CART_OBJECT_LABEL: 'Ajouter au panier',
  PRODUCT_LIST_ORDER_LABEL: 'LISTE DE PRODUITS',
  ORDER_TOTAL_LABEL: 'Total du panier',
  CHECKOUT_ORDER_BUTTON: 'CONTINUER À LA CAISSE',
  PREVIEW_ORDER_BUTTON: 'Aperçu de la Commande',
  VARIANT_ORDER_ITEM_LABEL: 'Une variante',
  QUANTITY_ORDER_ITEM_LABEL: 'Quantité',
  PRODUCT_ADDED_TOAST_LABEL: 'Produit ajouté!',
  CHECKOUT_ORDER_TOAST_LABEL: 'Demande envoyée!',
  COMPONENTS_OBJECT_LABEL: 'Composants',
  ORDER_DETAIL_TITLE_LABEL: 'Détails de la commande',
  ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Attributs personnalisés',
  SUBMIT_LABEL: 'Soumettre',
  ADD_TO_CART_LABEL: 'Ajouter l\'article au panier',
  CUSTOMIZED_VARIANT: 'Personnalisé',
  PRODUCTLIST: 'Liste de produits',
  PRODUCTLISTDOCLABEL_ITEMNAME: 'Nom de l\'article',
  PRODUCTLISTDOCLABEL_VARIATION: 'Variation',
  PRODUCTLISTDOCLABEL_COLLECTION: 'Collection',
  PRODUCTLISTDOCLABEL_COMPOSITION: 'Composition',
  PRODUCTLISTDOCLABEL_QUANTITY: 'Quantité',
  NAVIGATE_BACK: 'Retourner',
  REMOVE: 'Retirer',
  CLEAR_CART: 'Vider le panier',
  RESULTS_FOR: 'résultats pour',
  NO_CONTENT_TEXT: 'Image non disponible',
  STANDARD: 'Standard',
  PARTS: 'les pièces',
  CUSTOMIZATIONS: 'Personnalisations',
  PRICE: 'Prix',
  TOTAL: 'Total',
  QUANTITY: 'Quantité',
  MEASURES: 'Mesures',
  CUSTOM_ATTRIBUTES: 'Attributs personnalisés',
  LOGIN_SUCCESSFUL: 'Connexion réussie',
  LOGIN_CREDENTIALS_NOT_VALID: 'Identifiants non valides',
  LOGIN_UNKNOWN_ERROR: 'Erreur inconnue',
  LOGIN_RECOVER_PASSWORD: 'Récupérer mot de passe',
  LOGIN_CHANGE_PASSWORD: 'Changer le mot de passe',
  LOGIN_USERNAME: 'Nom d\'utilisateur',
  LOGIN_PASSWORD: 'Mot de passe',
  LOGIN_OLD_PASSWORD: 'Ancien mot de passe',
  LOGIN_NEW_PASSWORD: 'Nouveau mot de passe',
  LOGIN_NEW_PASSWORD_REPEAT: 'Répété le nouveau mot de passe',
  LOGIN_ACTION_LOGIN: 'Se connecter',
  RECOVER_PASSWORD_MESSAGE: 'Un nouveau mot de passe a été envoyé à votre email.',
  CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'La modification du mot de passe a réussi.',
  CHANGE_PASSWORD_ERROR_MESSAGE: 'Il y a facilement une erreur en essayant de changer le mot de passe.',
  CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'Le nouveau mot de passe correspond en grande partie au nouveau mot de passe répété.',
  GO_BACK_ACTION: 'Dos',
  CONFIRM_ACTION: 'Confirmer',
  SIGN_OUT_ACTION: 'Se déconnecter',
  OK_ACTION: 'D\'accord',
  CANCEL_ACTION: 'Annuler',
  RETRY_ACTION: 'Recommencez',
  RESEND_ACTION: 'Renvoyer',
  ERROR_LABEL: 'Erreur',
  SUCCESS_LABEL: 'Succès',
  ORDER_ERROR_MESSAGE: 'Une erreur s\'est produite lors de la tentative de soumission de la commande.',
  ORDER_SUCCESS_MESSAGE: 'La soumission de la commande a réussi.',
  DEMO_ORDER_ERROR_MESSAGE: 'Processus de commande en mode démo terminé avec succès.',
  DEMO_ORDER_SUCCESS_MESSAGE: 'Processus de commande en mode démo terminé avec succès.',
  VALIDATION_POP_UP_TITLE: 'Validation par e-mail',
  VALIDATION_POP_UP_MESSAGE: 'Veuillez insérer le code envoyé à votre email:',
  VALIDATION_POP_UP_ERROR: 'Le code ne correspond pas',
  DEMO_WARNING: 'À des fins de démonstration uniquement !',
  REPORT_ORDER_INFO_TITLE: 'Données de commande',
  REPORT_TITLE_DESCRIPTION: 'Description',
  REPORT_TITLE_VALUE: 'Valeur',
  REPORT_TITLE_QUANTITY: 'Quant.',
  REPORT_TITLE_PRICE: 'Prix',
  REPORT_TITLE_SCREENSHOT: 'Capture d’écran',
  REPORT_TITLE_KEY: 'Nom',
});
